// import React, { useEffect, useState } from "react";
// import "../assets/SalaryMaster.css";
// import { fetchEmployeeReport } from "../redux/slices/employeeReportSlice";
// import { useDispatch, useSelector } from "react-redux";

// const SalaryMaster = () => {
//   const dispatch = useDispatch();
//   const [selectedEmployee, setSelectedEmployee] = useState("");
//   // const [selectedEmployeeDetail, setSelectedEmployeeDetail] = useState();
//   const { list: data, loading, error, currentPage, totalPages } = useSelector(
//       (state) => state.employeeReport
//     );

//   const pageSize = 15;
    
//   const fetchData = (page = 1) => {
//     dispatch(fetchEmployeeReport({ page, pageSize }));
//   };

//   useEffect(() => {
//     fetchData(1);
//   }, []);

//   console.log("selected employee is ",selectedEmployee);
 
//   const superAdminId = localStorage.getItem("adminuserId") || "14";
//   return (
//     <div className="SalaryMaster-container">
//       <h2 className="SalaryMaster-title">Salary Master</h2>

//       {/* Filter Section */}
//       <div className="SalaryMaster-section">
//         <h3 className="SalaryMaster-subtitle">Employee Salary</h3>
//         <div className="SalaryMaster-grid">
//           <div className="SalaryMaster-field">
//             <label>Enter Employee ID *</label>
//             {/* <input type="text" placeholder="Enter Employee ID" /> */}
//              <select
//               value={selectedEmployee}
//               onChange={(e) => setSelectedEmployee(e.target.value)}
//             >
//               <option value="">Select Employee</option>
//               {data.map((emp) => (
//                 <option key={emp.id} value={emp.fullName}>
//                   {emp.fullName}- {emp.id}
//                 </option>
//               ))}
//             </select>
//           </div>
         
//           {/* <div className="SalaryMaster-field">
//             <label>Employee Name *</label>
//             <input type="text" placeholder="Enter Employee Name" />
//           </div> */}
//           <div className="SalaryMaster-field">
//             <label>Branch *</label>
//             <input type="text" placeholder="Branch" />
//           </div>
//           {/* <div className="SalaryMaster-field">
//             <label>Designation *</label>
//             <input type="text" placeholder="Designation" />
//           </div> */}
//         </div>
//       </div>

//       {/* Employee Account Details */}
//       <div className="SalaryMaster-section">
//         <h3 className="SalaryMaster-subtitle">Employee Account Details</h3>
//         <div className="SalaryMaster-grid">
//           <div className="SalaryMaster-field">
//             <label>Internal Account No.</label>
//             <input type="text" placeholder="Internal Account No." />
//           </div>
//           <div className="SalaryMaster-field">
//             <label>Bank Account No. *</label>
//             <input type="text" placeholder="Enter Bank Account No." />
//           </div>
//           <div className="SalaryMaster-field">
//             <label>Bank IFSC Code *</label>
//             <input type="text" placeholder="Enter IFSC Code" />
//           </div>
//           <div className="SalaryMaster-field">
//             <label>Account Holder Name *</label>
//             <input type="text" placeholder="Enter Bank Account Name" />
//           </div>
//           <div className="SalaryMaster-field">
//             <label>Bank Name *</label>
//             <input type="text" placeholder="Enter Bank Name" />
//           </div>
//         </div>
//       </div>

//       {/* Payment Section */}
//       <div className="SalaryMaster-section">
//         <h3 className="SalaryMaster-subtitle">Payment</h3>
//         <div className="SalaryMaster-grid">
//           <div className="SalaryMaster-field">
//             <label>No. of Days *</label>
//             <input type="number" placeholder="Enter No. of Days" />
//           </div>
//           <div className="SalaryMaster-field">
//             <label>Gross Salary *</label>
//             <input type="number" placeholder="Enter Gross Salary" />
//           </div>
//           <div className="SalaryMaster-field">
//             <label>Basic Pay *</label>
//             <input type="number" placeholder="Enter Basic Pay %" />
//             <input type="number" placeholder="Basic Pay Value" />
//           </div>
//           <div className="SalaryMaster-field">
//             <label>HRA *</label>
//             <input type="number" placeholder="Enter HRA %" />
//             <input type="number" placeholder="HRA Value" />
//           </div>
//           <div className="SalaryMaster-field">
//             <label>TA *</label>
//             <input type="number" placeholder="Enter TA %" />
//             <input type="number" placeholder="TA Value" />
//           </div>
//           <div className="SalaryMaster-field">
//             <label>DA *</label>
//             <input type="number" placeholder="Enter DA %" />
//             <input type="number" placeholder="DA Value" />
//           </div>
//           <div className="SalaryMaster-field">
//             <label>Medical Allowance *</label>
//             <input type="number" placeholder="Enter Medical Allowance %" />
//             <input type="number" placeholder="Medical Allowance Value" />
//           </div>
//           <div className="SalaryMaster-field">
//             <label>Incentive *</label>
//             <input type="number" placeholder="Incentive" />
//           </div>
//           <div className="SalaryMaster-field">
//             <label>Bonus *</label>
//             <input type="number" placeholder="Bonus" />
//           </div>
//           <div className="SalaryMaster-field">
//             <label>Total Payable *</label>
//             <input type="number" placeholder="Total Payable" />
//           </div>
//         </div>
//       </div>

//       {/* Deductions Section */}
//       <div className="SalaryMaster-section">
//         <h3 className="SalaryMaster-subtitle">Deductions</h3>
//         <div className="SalaryMaster-grid">
//           <div className="SalaryMaster-field">
//             <label>PF *</label>
//             <input type="number" placeholder="Enter PF %" />
//             <input type="number" placeholder="PF Value" />
//           </div>
//           <div className="SalaryMaster-field">
//             <label>TDS *</label>
//             <input type="number" placeholder="Enter TDS %" />
//             <input type="number" placeholder="TDS Value" />
//           </div>
//           <div className="SalaryMaster-field">
//             <label>Insurance *</label>
//             <input type="number" placeholder="Enter Insurance %" />
//             <input type="number" placeholder="Insurance Value" />
//           </div>
//           <div className="SalaryMaster-field">
//             <label>Other Deductions</label>
//             <input type="number" placeholder="Enter Other Deductions" />
//           </div>
//         </div>
//       </div>

//       {/* Summary Cards */}
//       <div className="SalaryMaster-summary-grid">
//   <div className="SalaryMaster-card allowance-bg">
//     <i className="fas fa-percentage SalaryMaster-icon"></i>
//     <span>Total Allowance Percentage</span>
//     <strong>0%</strong>
//   </div>

//   <div className="SalaryMaster-card net-bg">
//     <i className="fas fa-wallet SalaryMaster-icon"></i>
//     <span>Total Amount</span>
//     <strong>₹0 / ₹0</strong>
//   </div>

//   <div className="SalaryMaster-card deduction-bg">
//     <i className="fas fa-chart-line SalaryMaster-icon"></i>
//     <span>Total Deduction Percentage</span>
//     <strong>0%</strong>
//   </div>

//   <div className="SalaryMaster-card other">
//     <i className="fas fa-file-invoice-dollar SalaryMaster-icon"></i>
//     <span>Total Deductions</span>
//     <strong>₹0</strong>
//   </div>

//   <div className="SalaryMaster-card bonus">
//     <i className="fas fa-money-bill-wave SalaryMaster-icon"></i>
//     <span>Total Allowances</span>
//     <strong>₹0</strong>
//   </div>
// </div>


//       {/* Submit Button */}
//       <div className="SalaryMaster-submitWrapper">
//         <button className="SalaryMaster-submit">Submit</button>
//       </div>
//     </div>
//   );
// };

// export default SalaryMaster;




import React, { useEffect, useState } from "react";
import "../assets/SalaryMaster.css";
import { fetchEmployeeReport } from "../redux/slices/employeeReportSlice";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { getBranches } from "../redux/slices/branchSlice";

const SalaryMaster = () => {
  const dispatch = useDispatch();
  const { list: data } = useSelector((state) => state.employeeReport);

  const pageSize = 1000;
  const superAdminId = localStorage.getItem("adminuserId") || "14";
  const initialformdata={
    branchId: "",
    employeeId: "",
    basic: "",
    hra: "",
    commission: "",
    fuelAllowance: "",
    mobileAllowance: "",
    specialAllowance: "",
    otherAllowance: "",
    pfDeductions: "",
    advanceDeductions: "",
    leavesDeductions: "",
    otherDeductions: "",
    totalSalary: "",
    transactionDate: "",
    salaryMonth: "",
    workingDays: "",
    ledgerAccountId: "1234",
    accountHolderName: "",
    accountNumber: "",
    bankName: "",
    ifscCode: "",
    status: "ACTIVE",
    superAdminId: superAdminId
  };

  const [formData, setFormData] = useState(initialformdata);

  const fetchData = (page = 1) => {
    dispatch(fetchEmployeeReport({ page, pageSize }));
    dispatch(getBranches({ page, pageSize }));
  };

  const { branches, totalRecords, loading, error } = useSelector(
      (state) => state.branch
    );


  useEffect(() => {
    fetchData(1);
  }, []);

  // const calculateTotalSalary = () => {
  //     const payment =
  //       Number(formData.basic || 0) +
  //       Number(formData.hra || 0) +
  //       Number(formData.commission || 0) +
  //       Number(formData.fuelAllowance || 0) +
  //       Number(formData.mobileAllowance || 0) +
  //       Number(formData.specialAllowance || 0) +
  //       Number(formData.otherAllowance || 0);

  //     const deduction =
  //       Number(formData.pfDeductions || 0) +
  //       Number(formData.advanceDeductions || 0) +
  //       Number(formData.leavesDeductions || 0) +
  //       Number(formData.otherDeductions || 0);

  //     return payment - deduction;
  //   };

  // useEffect(() => {
  // setFormData((prev) => ({
  //       ...prev,
  //       totalSalary: calculateTotalSalary()
  //     }));
  //   }, [
  //     formData.basic,
  //     formData.hra,
  //     formData.commission,
  //     formData.fuelAllowance,
  //     formData.mobileAllowance,
  //     formData.specialAllowance,
  //     formData.otherAllowance,
  //     formData.pfDeductions,
  //     formData.advanceDeductions,
  //     formData.leavesDeductions,
  //     formData.otherDeductions
  //   ]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    const payload = {
      ...formData,
      transactionDate: new Date().toISOString().slice(0, 10),
      salaryMonth: new Date().toISOString().slice(0, 7)
    };
    console.log(formData);

    try {
      const response = await axios.post(
        "https://payyug.in/api/create-salary-structure",
        payload
      );

      alert("Salary Structure Created Successfully");
      console.log("API Response:", response.data);
      setFormData(initialformdata);
    } catch (error) {
      console.error("API Error:", error.response || error);
      alert("Failed to create salary structure");
    }
  };

  return (
    <div className="SalaryMaster-container">
      <h2 className="SalaryMaster-title">Salary Master</h2>

      {/* Employee Salary */}
      <div className="SalaryMaster-section">
        <h3 className="SalaryMaster-subtitle">Employee Salary</h3>
        <div className="SalaryMaster-grid">
          <div className="SalaryMaster-field">
            <label>Branch *</label>
            {/* <input
              type="text"
              placeholder="Branch"
              name="branchId"
              onChange={handleChange}
            /> */}
            <select
              value={formData.branchId}
              onChange={(e) =>
                setFormData({ ...formData, branchId: e.target.value })
              }
            >
              <option value="">Select Branch</option>
              {branches.map((emp) => (
                <option key={emp.id} value={emp.id}>
                  {emp.name}- {emp.id}
                </option>
              ))}
            </select>
          </div>
          <div className="SalaryMaster-field">
            <label>Enter Employee ID *</label>
            <select
              value={formData.employeeId}
              onChange={(e) =>
                setFormData({ ...formData, employeeId: e.target.value })
              }
            >
              <option value="">Select Employee</option>
              {data.map((emp) => (
                <option key={emp.id} value={emp.id}>
                  {emp.fullName}- {emp.id}
                </option>
              ))}
            </select>
          </div>

        </div>
      </div>

      {/* Account Details */}
      <div className="SalaryMaster-section">
        <h3 className="SalaryMaster-subtitle">Employee Account Details</h3>
        <div className="SalaryMaster-grid">
          {/* <div className="SalaryMaster-field">
            <label>Ledger Account ID</label>
            <input
              type="number"
               value={formData.ledgerAccountId}
              placeholder="Ledger Account ID"
              name="ledgerAccountId"
              onChange={handleChange}
            />
          </div> */}

          <div className="SalaryMaster-field">
            <label>Bank Account No. *</label>
            <input
              type="text"
               value={formData.accountNumber}
              placeholder="Account Number"
              name="accountNumber"
              onChange={handleChange}
            />
          </div>

          <div className="SalaryMaster-field">
            <label>IFSC Code *</label>
            <input
              type="text"
               value={formData.ifscCode}
              placeholder="IFSC Code"
              name="ifscCode"
              onChange={handleChange}
            />
          </div>

          <div className="SalaryMaster-field">
            <label>Account Holder *</label>
            <input
              type="text"
               value={formData.accountHolderName}
              placeholder="Account Holder Name"
              name="accountHolderName"
              onChange={handleChange}
            />
          </div>

          <div className="SalaryMaster-field">
            <label>Bank Name *</label>
            <input
              type="text"
               value={formData.bankName}
              placeholder="Bank Name"
              name="bankName"
              onChange={handleChange}
            />
          </div>
        </div>
      </div>

     
      {/* Payment */}
      <div className="SalaryMaster-section">
        <h3 className="SalaryMaster-subtitle">Payment</h3>
        <div className="SalaryMaster-grid">

          <div className="SalaryMaster-field">
            <label>No. of Days *</label>
            <input
              type="number"
              value={formData.workingDays}
              placeholder="Working Days"
              name="workingDays"
              onChange={handleChange}
            />
          </div>

          <div className="SalaryMaster-field">
            <label>Basic Pay</label>
            <input
              type="number"
              value={formData.basic}
              placeholder="Basic Pay"
              name="basic"
              onChange={handleChange}
            />
          </div>

          <div className="SalaryMaster-field">
            <label>HRA</label>
            <input
              type="number"
               value={formData.hra}
              placeholder="HRA"
              name="hra"
              onChange={handleChange}
            />
          </div>

          <div className="SalaryMaster-field">
            <label>Incentive / Commission</label>
            <input
              type="number"
               value={formData.commission}
              placeholder="Commission"
              name="commission"
              onChange={handleChange}
            />
          </div>

          <div className="SalaryMaster-field">
            <label>Fuel Allowance</label>
            <input
              type="number"
               value={formData.fuelAllowance}
              placeholder="Fuel Allowance"
              name="fuelAllowance"
              onChange={handleChange}
            />
          </div>

          <div className="SalaryMaster-field">
            <label>Mobile Allowance</label>
            <input
              type="number"
               value={formData.mobileAllowance}
              placeholder="Mobile Allowance"
              name="mobileAllowance"
              onChange={handleChange}
            />
          </div>

          <div className="SalaryMaster-field">
            <label>Special Allowance</label>
            <input
              type="number"
               value={formData.specialAllowance}
              placeholder="Special Allowance"
              name="specialAllowance"
              onChange={handleChange}
            />
          </div>

          <div className="SalaryMaster-field">
            <label>Other Allowance</label>
            <input
              type="number"
              value={formData.otherAllowance}
              placeholder="Other Allowance"
              name="otherAllowance"
              onChange={handleChange}
            />
          </div>

         <div className="SalaryMaster-field">
            <label>Total Salary </label>
            <input
              type="number"
              value={formData.totalSalary}
              placeholder="Total Salary"
              name="totalSalary"
              onChange={handleChange}
            />
          </div>


        </div>
      </div>


      {/* Deductions */}
        <div className="SalaryMaster-section">
          <h3 className="SalaryMaster-subtitle">Deductions</h3>
          <div className="SalaryMaster-grid">

            <div className="SalaryMaster-field">
              <label>PF Deduction</label>
              <input
                type="number"
                 value={formData.pfDeductions}
                placeholder="PF Deduction"
                name="pfDeductions"
                onChange={handleChange}
              />
            </div>

            <div className="SalaryMaster-field">
              <label>Advance Deduction</label>
              <input
                type="number"
                 value={formData.advanceDeductions}
                placeholder="Advance Deduction"
                name="advanceDeductions"
                onChange={handleChange}
              />
            </div>

            <div className="SalaryMaster-field">
              <label>Leave Deduction</label>
              <input
                type="number"
                 value={formData.leavesDeductions}
                placeholder="Leave Deduction"
                name="leavesDeductions"
                onChange={handleChange}
              />
            </div>

            <div className="SalaryMaster-field">
              <label>Other Deductions</label>
              <input
                type="number"
                 value={formData.otherDeductions}
                placeholder="Other Deductions"
                name="otherDeductions"
                onChange={handleChange}
              />
            </div>

          </div>
        </div>


      {/* Submit */}
      <div className="SalaryMaster-submitWrapper">
        <button className="SalaryMaster-submit" onClick={handleSubmit}>
          Submit
        </button>
      </div>
    </div>
  );
};

export default SalaryMaster;

